export default "__VITE_ASSET__dd3f1366__"